import * as React from "react";
import { MapPin, Phone, Mail, ArrowRight, Facebook, Instagram } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
const services = ["Architecture", "Interior Design", "Construction", "Renovation", "Turnkey Projects", "Project Management"];
const serviceAreas = ["Portfolio", "Disciplines", "The Studio", "Our Process", "Structural Integrity", "Contact"];
const socialLinks = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}];
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="265059" id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block w-fit">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs font-default">
              Founded in 2007, ArchiForma delivers complete turnkey solutions for residential and commercial projects with a modern, functional, and timeless approach.
            </p>
            <div className="flex items-center gap-2 mt-2">
              {socialLinks.map((social, i) => {
              const LogoComponent = social.icon;
              return <Button key={i} data-index={i} variant="ghost" size="icon" asChild className="text-muted-foreground hover:text-primary hover:bg-primary/5 rounded-md border border-border transition-all">
                    <Link to={social.href} aria-label={social.label}>
                      <LogoComponent className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight uppercase">
              Our Services
            </h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-muted-foreground hover:text-primary text-sm transition-colors inline-flex items-center gap-2 group font-default">
                    <ArrowRight className="size-3 opacity-0 -ml-5 transition-all group-hover:opacity-100 group-hover:ml-0 text-primary" />
                    {service}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight uppercase">
              Quick Links
            </h3>
            <ul className="flex flex-col gap-3">
              {serviceAreas.map((area, i) => <li key={i} data-index={i}>
                  <Link to="#" className="text-muted-foreground hover:text-primary text-sm transition-colors inline-flex items-center gap-2 group font-default">
                    <ArrowRight className="size-3 opacity-0 -ml-5 transition-all group-hover:opacity-100 group-hover:ml-0 text-primary" />
                    {area}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-default text-lg font-bold tracking-tight uppercase">
              Contact Us
            </h3>
            <ul className="flex flex-col gap-4">
              <li>
                <Link to="#" className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <MapPin className="size-5 shrink-0 mt-0.5 text-primary/60 group-hover:text-primary transition-colors" />
                  <span className="text-sm leading-tight font-default">
                    Yerevan, Armenia<br />
                    Architectural District
                  </span>
                </Link>
              </li>
              <li>
                <Link to="#" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Phone className="size-5 shrink-0 text-primary/60 group-hover:text-primary transition-colors" />
                  <span className="text-sm font-default">+374 (93) 999-936</span>
                </Link>
              </li>
              <li>
                <Link to="#" className="flex items-center gap-3 text-muted-foreground hover:text-primary transition-colors group">
                  <Mail className="size-5 shrink-0 text-primary/60 group-hover:text-primary transition-colors" />
                  <span className="text-sm font-default">info@archiforma.am</span>
                </Link>
              </li>
            </ul>
          </div>

        </div>

        <Separator className="my-8 bg-border" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground font-mono uppercase tracking-widest">
          <p>
            &copy; {currentYear} ArchiForma. Creating Spaces With Purpose.
          </p>
          <div className="flex items-center gap-4">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors">
              Terms
            </Link>
            <Button variant="ghost" size="sm" onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="flex items-center gap-1 hover:text-primary transition-colors cursor-pointer p-0 h-auto font-mono uppercase tracking-widest text-xs">
              Back to Top <ArrowRight className="-rotate-90 size-3" />
            </Button>
          </div>
        </div>
        <p className="mt-6 text-center md:text-left">
          <Link to="https://www.onesourceit.am/" newTab className="text-[10px] text-muted-foreground/60 hover:text-primary hover:underline transition-colors font-mono uppercase tracking-tighter">
            Developed by OneSourceIT
          </Link>
        </p>
      </div>
    </section>;
}